module.exports = __webpack_public_path__ + "img/shequ-4.c11e7709.png";